import Cloud from "lucide-react/dist/esm/icons/cloud";
import KeyRound from "lucide-react/dist/esm/icons/key-round";
import LockKeyhole from "lucide-react/dist/esm/icons/lock-keyhole";
import { useState } from "react";
import { useLibraryStore } from "../store/libraryStore";

export function AccessGate() {
  const error = useLibraryStore((state) => state.authError);
  const [token, setToken] = useState("");
  const [working, setWorking] = useState(false);

  async function unlock(event: React.FormEvent) {
    event.preventDefault();
    if (!token.trim()) return;
    setWorking(true);
    await useLibraryStore.getState().unlockLibrary(token);
    setWorking(false);
  }

  return <main className="access-screen">
    <section className="access-window" aria-labelledby="access-title">
      <div className="access-titlebar"><LockKeyhole size={13} /> PRIVATE CLOUD LIBRARY</div>
      <div className="access-body">
        <div className="access-mark"><Cloud size={30} /><span>ND</span></div>
        <div><h1 id="access-title">NEEDLE DROP ACCESS</h1><p>This library is private. Enter the shared access code to load the same tracks, playlists and metadata on this device.</p></div>
      </div>
      <form onSubmit={(event) => void unlock(event)}>
        <label>LIBRARY ACCESS CODE<div className="access-input"><KeyRound size={14} /><input autoFocus type="password" autoComplete="current-password" value={token} onChange={(event) => setToken(event.target.value)} /></div></label>
        {error && <p className="access-error" role="alert">{error}</p>}
        <button className="bevel-button primary-tool" disabled={working || !token.trim()}>{working ? "CONNECTING…" : "OPEN LIBRARY"}</button>
      </form>
      <small>Audio is stored in a private Cloudflare R2 bucket and is never publicly exposed.</small>
    </section>
  </main>;
}
